import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { Row, Col, ButtonGroup, Button, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { useParams, useNavigate, Link } from "react-router-dom";
import PageTitle from '../../../components/PageTitle/PageTitle';
import Role from '../../../components/Role/Role';
import Icon from '@mdi/react';
import {
    mdiAccountCircleOutline,
    mdiCardAccountMailOutline,
    mdiCardAccountPhoneOutline,
    mdiCommentAccountOutline,
} from '@mdi/js';

import { Utils } from '../../../services/';
import { loadUser } from '../../../redux/modules/users';

const UserShow = () => {
    const { userId } = useParams();

    const navigate = useNavigate();
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadUser(userId));
    }, [ dispatch, userId ]);

    const { t }        = useTranslation();
    const { user }     = useSelector(state => state.users);
    const current_user = useSelector(state => state.auth.user);

    if (!current_user || !user)
        return null;

    if (!current_user.isAdmin() && (current_user.id !== user.id))
        return navigate('/');

    const title = current_user.id === user.id ?
        <span>{t('users.my_profile')}</span>
        :
        <span>
            {t('users.user')}
            <small> | { user.firstname } { user.lastname }</small>
        </span>

    const actions =
    <div>
        <ButtonGroup>
            <Role has="admin">
                <Button tag={Link} to={ -1 } color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;{t('common.back')}
                </Button>
            </Role>
            {user &&
                <Button tag={Link} to={ `/users/edit/${ user.id }` } color="info" size="sm">
                    <i className="fa fa-edit"></i>&nbsp;{t('common.edit')}
                </Button>
            }
        </ButtonGroup>
    </div>

    return (
        <div className="UserShow">
            <PageTitle icon="users" title={ title } actions={ actions } />
            {user &&
                <div>
                    <Row>
                        <Col sm={12} lg={6}>
                            <Card color="light">
                                <CardBody>
                                    <CardTitle tag="h3">
                                        <Icon path={mdiAccountCircleOutline} size={1.5} />
                                        {t('users.profile')}
                                    </CardTitle>
                                    <CardText tag="div">
                                        <div><b>{t('users.firstname')}</b>: { user.firstname }</div>
                                        <div><b>{t('users.lastname')}</b>: { user.lastname }</div>
                                        <div><b>{t('users.role')}</b>: { Utils.roles(user.role).label }</div>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm={12} lg={6}>
                            <Card color="light">
                                <CardBody>
                                    <CardTitle tag="h3">
                                        <Icon path={mdiCardAccountPhoneOutline} size={1.5} />&nbsp;
                                        {t('users.contact')}
                                    </CardTitle>
                                    <CardText tag="div">
                                        <div><b>{t('users.email')}</b>: { user.email }</div>
                                        <div><b>{t('users.mobile_phone')}</b> : { user.phone }</div>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col sm={12} lg={6}>
                            <Card color="light">
                                <CardBody>
                                    <CardTitle tag="h3">
                                        <Icon path={mdiCardAccountMailOutline} size={1.5} />&nbsp;
                                        {t('users.address')}
                                    </CardTitle>
                                    <CardText tag="div">
                                        <div>{ user.address }</div>
                                        <div>{ user.zip } {user.city }</div>
                                        <div>{ user.country }</div>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm={12} lg={6}>
                            <Card color="light">
                                <CardBody>
                                    <CardTitle tag="h3">
                                        <Icon path={mdiCommentAccountOutline} size={1.5} />&nbsp;
                                        {t('users.remarks')}
                                    </CardTitle>
                                    <CardText tag="div">
                                        <div>{ user.remarks }</div>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            }
        </div>
    );
}

export default UserShow;
